var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_11464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3203 0C4.80609 0 0.320312 4.48578 0.320312 10C0.320312 15.5142 4.80609 20 10.3203 20C15.8345 20 20.3203 15.5142 20.3203 10C20.3203 4.48578 15.8345 0 10.3203 0ZM14.6953 10.8333H11.1536V14.375C11.1536 14.8351 10.7804 15.2083 10.3203 15.2083C9.86026 15.2083 9.48703 14.8351 9.48703 14.375V10.8333H5.94531C5.48526 10.8333 5.11203 10.4601 5.11203 10C5.11203 9.53995 5.48526 9.16672 5.94531 9.16672H9.48703V5.625C9.48703 5.16495 9.86026 4.79172 10.3203 4.79172C10.7804 4.79172 11.1536 5.16495 11.1536 5.625V9.16672H14.6953C15.1554 9.16672 15.5286 9.53995 15.5286 10C15.5286 10.4601 15.1554 10.8333 14.6953 10.8333Z",
    fill: "#2468FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_11464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.320312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/Add-icon.201794b0.svg";
export { ForwardRef as ReactComponent };